if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }
  });
}
